<template>
	<div class="view-recruit-warp">

		<!-- 城事精选 	-->
		<div v-show="true" class="menu-components" style="height: 100%;">		 
			<div class="canyu-list-wrap">
				<van-list v-model="loading" :finished="finished" @load="onLoad" :offset="300">
					<van-cell v-for="item in list" :key="item.id" @click="displayArticle(item.ID,item.cid)">
						<div> 
							<div class="quancun-list-img"  v-lazy:background-image="item.thumbnail">
								<!--<img src="static/img/pay/recruit/logo.png"/>-->
							</div>
							<div class="newbao-list-content">
								<div>
									<div class="content-title">{{item.LongTitle}}</div>								
									<div class="quancun-list-bottom">
										<span>互动活动</span>
										<span  class="eye-wrap"><img class="eye" src="static/img/eye.png"/>888</span>
									</div>
								</div>
								<div>
									<img src="static/img/pay/recruit/go.png"/>
								</div>
							</div>
						</div>
					</van-cell>
				</van-list>
				<div style="height:1.37rem;"></div>
			</div>
		</div>

		<!-- 文章 	-->
		<div v-show="true" class="menu-components"  v-bind:style="{ height: newClass.articleHeight,borderTop:0}">			  
			<div class="newbao-list-wrap" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;height: 100%;">
				<van-loading class="conents-loading" color="white" v-if="conentsLoading"/>
				<iframe v-bind:style="{ height:iframeHeight}"  @load="iframeLoaded" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;  " :src="articleSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0"></iframe>
			</div>
		</div>
		
		<!-- 底部导航 -->
		<van-tabbar v-model="active" class="bottom-nav" v-bind:style="{ backgroundColor:  activeColor }">
			<van-tabbar-item :to="{path:'/',query:{view:1}}">
				<span>鲜料</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.newsActive : icon.news" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item :to="'/maps'">
				<span>智图</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.mapsActive : icon.maps"  />
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="displayList">
				<span>趣玩</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.payActive : icon.pay"/>
				</template>
			</van-tabbar-item>
			<van-tabbar-item :to="{path:'/',query:{view:4}}">
				<span>服务</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.serviceActive: icon.service"  />
				</template>
			</van-tabbar-item>
		</van-tabbar>

	</div>
</template>

<script>
	import { Tabbar, TabbarItem, Toast, CellGroup } from 'vant'
	import { NavBar, Tab, Tabs, Search, Button, Field, Popup, Tag } from 'vant'
	import qs from 'qs'
	import { List, Cell } from 'vant'
	import { Row, Col } from 'vant'
	import { Loading } from 'vant'
  import request from '@/utils/request'
  
  
	export default {
		name: 'PlayRecruit',
		components: {
			'van-tabbar': Tabbar,
			'van-tabbar-item': TabbarItem,
			'van-nav-bar': NavBar,
			'van-tabs': Tabs,
			'van-tab': Tab,
			'van-search': Search,
			'van-popup': Popup,
			'van-field': Field,
			'van-cell-group': CellGroup,
			'van-button': Button,
			'van-list': List,
			'van-cell': Cell,
			'van-tag': Tag,
			'van-col': Col,
			'van-row': Row,
			'van-loading':Loading
		},
		data() {
			return {
        //HOST:'http://localhost:55214/Server',
        HOST:'http://z.lzgd.com.cn/LiuzhouTourism/Server',
				active: 2,
				icon: {
					news: 'static/img/tabbar/white/news.png',
					newsActive: 'static/img/tabbar/white/news-active.png',
					maps: 'static/img/tabbar/white/map6.png',
					mapActive: 'static/img/tabbar/white/map-active.png',
					pay: 'static/img/tabbar/white/pay.png',
					payActive: 'static/img/tabbar/white/pay-active.png',
					service: 'static/img/tabbar/white/service.png',
					serviceActive: 'static/img/tabbar/white/service-active.png',
				},listQuery: {
              pageIndex: 1,
              pageSize: 10,
            }
        ,
        newsType:1,
				activeColor: "#222633",
				//鲜料
				newComponentsShow: false,
				titleHeight: '55px',
				navIconHeight: '0',
				newClass: {
					activeHeight: '0',
					articleHeight:'0',
				},

				/* 新料快报 */
				list: [],
				loading: false,
				finished: false,
				newsBaoClass: {
					newbaoListHeight: '212px',
				},
				/* 文章 */
				iframeHeight:'0',
				conentsLoading:true,
				articleSrc:'',
			}
		},
		mounted() {
			let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			let elementWith = (w * 0.1826);
			if(w >= 750) {
				elementWith = 137;
				w = 750;
			}
			this.titleHeight = elementWith + 'px';
			this.navIconHeight = (elementWith * 0.3764) + 'px';
			this.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			let vm = this;
			window.onresize = function temp() {
				let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
				let elementWith = (w * 0.1826);
				if(w >= 750) {
					elementWith = 137;
					w = 750;
				}
				vm.titleHeight = elementWith + 'px'
				vm.navIconHeight = (elementWith * 0.3764) + 'px';
				vm.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			};
		},
		created() {
    				document.title = '互动活动'
            this.newsType = 205
		},
		methods: {
			
    //
      getData(cid){
        console.log('cid',cid);
        console.log('HOST',this.HOST);
        let vm  = this;       
        //Toast('正在加载...');//return;
        let data =this.listQuery;
        data.cid = cid;
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getByCategory',data)
      .then(function (res) {
          vm.loading = false;
        if(res.data.state==1){ 
          console.log(res.data)
          for(var i =0;i<res.data.list.length;i++){
            try{
              vm.list.push(res.data.list[i]);
            }catch(e){
              
            }
          }  
          if(res.data.list.length<=0){
            Toast('已是最后一页');
            vm.finished = true;
          }else{
            vm.listQuery.pageIndex++;
          }
          //vm.list.push(res.data.list);  
          //Toast.clear();
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        console.log(response);
      });
        
        
        
      },
			onLoad() {
			  
        if(!this.finished){
        console.log('onLoad:',new Date());
        this.getData(this.newsType);
      }
        return;
				
        	let data = 
        	[ 
        			{id:1,type:204,typeName:'互动活动',visits:888,title:'这一场蛰伏已久的狂想盛宴，即将嗨爆这个夏天！',addTime:'2018-01-01 00:00:00',pic:'http://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/article/quwan/204/1/list.jpg'},
		        		{id:2,type:204,typeName:'互动活动',visits:888,title:'怀远古城印象——丹洲古城老照片有奖征集',addTime:'2018-01-01 00:00:00',pic:'http://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/article/quwan/204/2/list.jpg'},
		        		
        	]
        	
			for(let i = 0; i < data.length; i++) {
        		//this.list.push(data[i]);
        	}
	        this.loading = false;
        this.list = data;
				
/*
				setTimeout(() => {
					for(let i = 0; i < 10; i++) {
						let obj = {
							title: '标题',
							id: this.list.length + 1
						};
						this.list.push(obj);
					}
					this.loading = false;

					if(this.list.length >= 40) {
						this.finished = true;
					}
				}, 500);*/
			},
			
		iframeLoaded(){console.log('iframeLoaded');
			this.iframeHeight='100%';
			this.conentsLoading = false;
		},
    	//显示文章
    	displayArticle(id,type){ 
    			
			this.conentsLoading = true;
    		if(this.newClass.articleHeight == '0'){  
    		 window.location.hash = '/PlayRecruit?id='+id;
	    		this.newClass.activeHeight = '0';
	    		this.newClass.articleHeight = '100%';	    		
          this.articleSrc =this.HOST+ '/View/Article.aspx?type='+type+'&id='+id;
	    		//this.articleSrc = 'http://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/Article.aspx?type='+type+'&id='+id;
	    		//this.articleSrc = 'http://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/Article.aspx?type='+type+'&id='+id;
    		}else{    			
	    		this.newClass.activeHeight = '100%';
	    		this.newClass.articleHeight = '0'; 	    		
	    		this.articleSrc = '';
    		}	
    		let vm  =this;
			setTimeout(function(){
				vm.conentsLoading = false;				
			},8000);
    	}
    	,displayList(){
    		
    		 
    				document.title = '互动活动'
	  			  
    		if(this.newClass.articleHeight != '0'){  	    	    			
	    		this.newClass.activeHeight = '100%';
	    		this.newClass.articleHeight = '0'; 	    		
	    		this.articleSrc = '';
    		 	window.location.hash = '/PlayRecruit';
    		}else{ 
	  	   	this.$router.push({
		          path: '/',
		          query: {
		            view: 2
		          }
		       });
    		}
    		
    		
    	}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
	
	.menu-components {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		width: 100%;
		height: 0;
		overflow: hidden;
		background-color: #FFF;
	-webkit-transition: top 250ms, height 400ms;
    transition: top 250ms, height 400ms;
	}
	.eye{
		width: 12%;
		margin-right: 0.05rem;
		margin-bottom: 0.02rem;
	}
</style>
<style>
	
.child-view {  
  position: absolute;  
  left: 0;  
  top: 0;  
  width: 100%;  
  height: 100%;  
  transition:none !important;   /*转场动画*/
}


</style>

<!-- 菜单 -->
<style scoped>
  
	.new-list-wrap {
		margin-top: 30px;
		margin-bottom: 100px;
	}
	
	.new-list-wrap .van-hairline::after,
	.new-list-wrap .van-hairline--top-bottom::after,
	.new-menu .van-hairline--top-bottom::after,
	.new-menu .van-hairline::after,
	.new-menu[class*=van-hairline]::after {
		border: 0 solid #FFFFFF !important;
	}
	
	.new-list {
		margin: 0 !important;
	}
	
	.new-list img {
		max-width: 100%;
	}
	
	.new-list .van-col:nth-child(odd) {
		margin-bottom: 0 !important;
		padding-left: 17px !important;
		padding-right: 6px !important;
	}
	
	.new-list .van-col:nth-child(even) {
		margin-bottom: 0 !important;
		padding-left: 6px !important;
		padding-right: 17px !important;
	}
	
	.content-title{ 		
		font-size: 0.34rem;
		line-height: 0.38rem;
		height:  1.2rem;
		/*将height设置为line-height的整数倍，防止超出的文字露出*/
		color: #222633;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
	}
</style>
<style> 
	/* 互动活动 */
	
	.view-recruit-warp .canyu-list-wrap {
		position: relative;
		height: calc(100% - 1.37rem);
		overflow-y: auto;
		overflow-x: hidden;
		margin-bottom: 100px;
    	-webkit-overflow-scrolling:touch;
	}
	.view-recruit-warp .canyu-list-wrap .van-cell {
		width: 100%;
		height: calc(5.59rem + 2.12rem + 0.2rem);
		padding: 0;
		border-top: 0.2rem solid #e8e9eb;
	}
	 
	.view-recruit-warp .canyu-list-wrap .van-cell__value--alone {
		
		/*height: calc(2.75rem + 2.12rem);*/
		 
	}
	
	 
	.view-recruit-warp .quancun-list-img {
		position: relative;
		width: 100%;
		height: 5.59rem;
		right: 0;
		top: 0;
		background-color: #FFF;
		background-position: center;
		background-size: auto 100%;
	}
	
	.view-recruit-warp .quancun-list-img img{
		margin-top: 0.35rem;
		margin-left: 0.35rem;
		width: 1.31rem;
	}
	
 
	.view-recruit-warp .newbao-list-content {
		position: relative;
		padding: 0.25rem 0.35rem;		
		height:  calc(2.12rem - 0.25rem - 0.25rem);
	}
	.view-recruit-warp .newbao-list-content>div:nth-child(1) {
		position: relative;
		width: 5.27rem;
		height: calc(2.12rem - 0.25rem - 0.25rem);
		float: left;
	}
	.view-recruit-warp .newbao-list-content>div:nth-child(2) {
		position: relative;
		width: 1.515rem;
		height: calc(2.12rem - 0.25rem - 0.25rem); 
		float: left;
	}
	.view-recruit-warp .newbao-list-content>div:nth-child(2) img {
		width: 86.75%;
		margin-left: 13.25%;
		margin-top: 13.25%;
	}
	
	.view-recruit-warp .quancun-list-bottom {
		position: absolute;
		bottom: 0;
		width: 100%;
		line-height: 0.26rem;
		font-size: 0.26rem;
		color: #8A8A8A;
	}
	
	.view-recruit-warp .quancun-list-bottom span:nth-child(1) {
		 
	}
	
	.view-recruit-warp .quancun-list-bottom span:nth-child(2) {
		position: absolute;		
		right: 0;
		top: 0;
		width: 30%;
		text-align: right;		
	}
	/* 互动活动 end*/
</style>


// WEBPACK FOOTER //
// src/components/funnyplay/Recruit.vue